import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-100 d-flex flex-wrap" }
const _hoisted_2 = { class: "container-fluid px-xl-5" }
const _hoisted_3 = { class: "py-5" }
const _hoisted_4 = { class: "text-center text" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus-circle" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BookList = _resolveComponent("BookList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, [
          _createTextVNode(_toDisplayString(_ctx.$t("messages.Available Books")) + " ", 1),
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.newBook()))
          }, [
            _hoisted_5,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("messages.Create new book")), 1)
          ])
        ]),
        _createVNode(_component_BookList)
      ])
    ])
  ]))
}